import Head from "next/head";

import ContactPage from "../components/ContactPage";
import { FlashPCBPage } from "../models/page";
import settings from "../constants/settings";
import { GoogleReCaptchaProvider } from "@google-recaptcha/react";

const Contact: FlashPCBPage = () => {
  return (
    <>
      <Head>
        <title>Contact FlashPCB</title>
        <meta
          name="description"
          content="Send us a message or find us online and in person"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <GoogleReCaptchaProvider
        type="v3"
        siteKey={settings.google_recaptcha_key}
      >
        <ContactPage />
      </GoogleReCaptchaProvider>
    </>
  );
};

export default Contact;
